import { useState } from 'react';
import { toast } from 'sonner';
import { ClipboardList, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImportBatizadosDialog({ state, setState, onImported }) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const importData = async () => {
    setErrors([]);
    if (!state.text.trim()) { toast.error('Cole a lista de batizados'); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API}/batismos/${state.batismoId}/registros/import`, {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ delimiter: state.delimiter, text: state.text }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) {
        const detail = data.detail;
        if (detail?.errors) setErrors(detail.errors);
        throw new Error(detail?.message || detail || 'Erro ao importar batizados');
      }
      const importErrors = data.errors?.length ? data.errors.map(err => `Linha ${err.line}: ${err.errors.join('; ')}`) : [];
      if (importErrors.length) setErrors(importErrors);
      toast.success(`Importação concluída: ${data.created || 0} criados, ${data.updated || 0} atualizados${data.skipped ? `, ${data.skipped} com erro` : ''}`);
      onImported();
      if (!importErrors.length) setState(prev => ({ ...prev, open: false }));
    } catch (err) { toast.error(err.message); } finally { setLoading(false); }
  };
  return (
    <Dialog open={state.open} onOpenChange={(open) => { setState(prev => ({ ...prev, open })); if (!open) setErrors([]); }}>
      <DialogContent className="max-w-3xl" data-testid="batizados-import-modal">
        <DialogHeader><DialogTitle>Importar Batizados</DialogTitle><DialogDescription>Cole uma linha por batizado no formato Nome|Idade|WhatsApp|Endereço|Comum. Linhas válidas serão importadas; linhas com erro serão listadas abaixo.</DialogDescription></DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div><Label>Divisor</Label><select value={state.delimiter} onChange={(e) => setState(prev => ({ ...prev, delimiter: e.target.value }))} className="mt-1 h-10 w-full rounded-md border border-input bg-white px-3 text-sm" data-testid="batizados-import-delimiter"><option value="|">|</option><option value=";">;</option><option value=",">,</option></select></div>
            <div className="sm:col-span-2 flex items-end"><p className="text-xs text-slate-500">Exemplo: Maria Silva{state.delimiter}19{state.delimiter}(11) 99999-9999{state.delimiter}Rua A, 123 São Paulo SP{state.delimiter}Central</p></div>
          </div>
          <div><Label>Lista de batizados</Label><textarea value={state.text} onChange={(e) => setState(prev => ({ ...prev, text: e.target.value }))} className="mt-1 min-h-[280px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm font-mono" placeholder={`Nome${state.delimiter}Idade${state.delimiter}WhatsApp${state.delimiter}Endereço${state.delimiter}Comum\nMaria Silva${state.delimiter}19${state.delimiter}(11) 99999-9999${state.delimiter}Rua A, 123 São Paulo SP${state.delimiter}Central`} data-testid="batizados-import-textarea" /></div>
          {errors.length > 0 && <div className="max-h-36 overflow-auto rounded-md border border-red-200 bg-red-50 p-3" data-testid="batizados-import-errors">{errors.map((err, idx) => <p key={idx} className="text-xs text-red-700">{err}</p>)}</div>}
          <Button onClick={importData} disabled={loading} className="w-full bg-[#069668] hover:bg-[#057f59]" data-testid="batizados-import-submit-button">{loading ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <ClipboardList className="w-4 h-4 mr-1.5" />}Importar batizados</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}